import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { Pagination, TableNoFilterResults } from '@morpho-org/ui-v6/client';
import { TableNoResults } from '@morpho-org/ui-v6/server';
import { TableQueryError } from '@/components/common/Error';
import { Table, TrBodyRow, TrHeaderGroup } from '@/components/common/Table';
import { TableScrollArea } from '@/components/common/Table/CompactTable/Table';
import { useDashboardLiquidationActivityTable } from '../hooks/useDashboardLiquidationActivityTable';
import { PARTIAL_LIQUIDATIONS_NOTICE } from '../partialNotice.constants';
import DashboardLiquidationActivityFilters from './DashboardLiquidationActivityFilters';
const noBorderRadiusStyle = {
  borderRadius: '0'
};
const DashboardLiquidationActivity = t0 => {
  const $ = _c(62);
  const {
    children
  } = t0;
  const {
    items,
    loading,
    partial,
    error,
    transactionsTable,
    hasNoTransactions,
    columnFilters,
    setColumnFilters,
    pagination,
    loadingRows
  } = useDashboardLiquidationActivityTable();
  let t1;
  if ($[0] !== items) {
    const itemChainIds = items.map(_temp);
    t1 = Array.from(new Set(itemChainIds));
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const availableChains = t1;
  let t2;
  if ($[2] !== availableChains || $[3] !== columnFilters || $[4] !== setColumnFilters) {
    t2 = {
      filters: columnFilters,
      setColumnFilters,
      availableChains,
      withGlobalSearch: true
    };
    $[2] = availableChains;
    $[3] = columnFilters;
    $[4] = setColumnFilters;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== children || $[7] !== t2) {
    t3 = <DashboardLiquidationActivityFilters filterProps={t2}>{children}</DashboardLiquidationActivityFilters>;
    $[6] = children;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== transactionsTable) {
    t4 = transactionsTable.getHeaderGroups().map(_temp2);
    $[9] = transactionsTable;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <Table.Thead>{t4}</Table.Thead>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== loading || $[14] !== loadingRows || $[15] !== transactionsTable) {
    t6 = loading ? loadingRows.map(_temp3) : transactionsTable.getRowModel().rows.map(_temp4);
    $[13] = loading;
    $[14] = loadingRows;
    $[15] = transactionsTable;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <Table.Tbody>{t6}</Table.Tbody>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t7) {
    t8 = <Table.Table tableVariant="compact-filter">{t5}{t7}</Table.Table>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== error || $[23] !== hasNoTransactions || $[24] !== items.length || $[25] !== loading || $[26] !== setColumnFilters) {
    t9 = !loading && hasNoTransactions && !error && <div className="border-border border-t-[0.5px]">{items.length === 0 ? <TableNoResults text="No liquidations yet." height="340px" withBackground={false} withBorder={false} style={noBorderRadiusStyle} /> : <TableNoFilterResults type="transactions" count={items.length} clearFilters={() => setColumnFilters?.([])} />}</div>;
    $[22] = error;
    $[23] = hasNoTransactions;
    $[24] = items.length;
    $[25] = loading;
    $[26] = setColumnFilters;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== error || $[29] !== loading) {
    t10 = !loading && error && <TableQueryError error={error} minHeight="340px" style={noBorderRadiusStyle} />;
    $[28] = error;
    $[29] = loading;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t8 || $[33] !== t9) {
    t11 = <TableScrollArea className="grid h-full w-full rounded-none rounded-b-[20px]">{t8}{t9}{t10}</TableScrollArea>;
    $[31] = t10;
    $[32] = t8;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== error || $[36] !== loading || $[37] !== partial) {
    t12 = partial && !loading && !error && <p className="text-secondary-foreground px-sm text-xs" data-testid="dashboard-liquidation-activity-partial-notice">{PARTIAL_LIQUIDATIONS_NOTICE}</p>;
    $[35] = error;
    $[36] = loading;
    $[37] = partial;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== transactionsTable) {
    t13 = transactionsTable.getRowCount();
    $[39] = transactionsTable;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  const t14 = transactionsTable.previousPage;
  const t15 = transactionsTable.nextPage;
  const t16 = transactionsTable.setPageIndex;
  let t17;
  if ($[41] !== transactionsTable) {
    t17 = transactionsTable.getCanPreviousPage();
    $[41] = transactionsTable;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== transactionsTable) {
    t18 = transactionsTable.getCanNextPage();
    $[43] = transactionsTable;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== error || $[46] !== loading || $[47] !== pagination || $[48] !== t13 || $[49] !== t17 || $[50] !== t18 || $[51] !== transactionsTable.nextPage || $[52] !== transactionsTable.previousPage || $[53] !== transactionsTable.setPageIndex) {
    t19 = <Pagination loading={loading} error={error} pagination={pagination} totalItemsCount={t13} previousPage={t14} nextPage={t15} setPage={t16} canPreviousPage={t17} canNextPage={t18} />;
    $[45] = error;
    $[46] = loading;
    $[47] = pagination;
    $[48] = t13;
    $[49] = t17;
    $[50] = t18;
    $[51] = transactionsTable.nextPage;
    $[52] = transactionsTable.previousPage;
    $[53] = transactionsTable.setPageIndex;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== t11 || $[56] !== t12 || $[57] !== t19) {
    t20 = <div className="gap-lg flex h-[100%] w-[100%] flex-col"><div className="gap-xs flex flex-col">{t11}{t12}{t19}</div></div>;
    $[55] = t11;
    $[56] = t12;
    $[57] = t19;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  let t21;
  if ($[59] !== t20 || $[60] !== t3) {
    t21 = <>{t3}{t20}</>;
    $[59] = t20;
    $[60] = t3;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  return t21;
};
export default DashboardLiquidationActivity;
function _temp(item) {
  return item.chainId;
}
function _temp2(headerGroup) {
  return <TrHeaderGroup key={headerGroup.id} headerGroup={headerGroup} />;
}
function _temp3(row, index) {
  return <TrBodyRow key={`skeleton-${index}`} skeletonRow={row} />;
}
function _temp4(row_0) {
  return <TrBodyRow key={`${row_0.id}-${row_0.original.tx.hash}`} row={row_0} />;
}